module.exports = __webpack_public_path__ + "static/img/banner3.3eb00c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 10